import { createSlice } from '@reduxjs/toolkit';
import { fetchPumpCheckerEvents } from '../../dispatchers/EventsDispatcher';

const initialState = {
  data: undefined,
  loading: false,
  error: undefined,
};

const PumpCheckerEventsSlice = createSlice({
  name: 'pumpCheckerEventsSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPumpCheckerEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPumpCheckerEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPumpCheckerEvents.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setInitialState } = PumpCheckerEventsSlice.actions;

export default PumpCheckerEventsSlice.reducer;
